'use es6';

import { VIEW_PDF_ZOOM, VIEW_PDF_PAGE, VIEW_PDF_RESET } from '../../constants/ActionTypes';
const initialState = {
  pageIndex: 0,
  zoom: 1.0
};
export default ((state = initialState, action) => {
  switch (action.type) {
    case VIEW_PDF_ZOOM:
      return Object.assign({}, state, {
        zoom: action.payload
      });

    case VIEW_PDF_PAGE:
      return Object.assign({}, state, {
        pageIndex: action.payload
      });

    case VIEW_PDF_RESET:
      return initialState;

    default:
      return state;
  }
});